module.exports = __webpack_public_path__ + "img/DW365-305.67469be5.jpg";